import { AppConstants } from '../app-constants';

export const getSelectTriggerText = (text: string, maxLength: number = AppConstants.SELECT_TRIGGER_LENGTH): string => {
    if (text && text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }

    return text;
};
